import { ReactNode } from 'react';

import cn from './styles.module.sass';

interface IWayToEarnItemProps {
    number: number;
    description: string | ReactNode;
}

export const WayToEarnItem = ({ number, description }: IWayToEarnItemProps) => {
    return (
        <div className={cn.container}>
            <span className={cn.number}>{number}</span>
            <span className={cn.description}>{description}</span>
        </div>
    );
};
